module.exports = "<span class=\"c-tree__item js-tree__item\"></span>\n<span class=\"c-tree__item-subtree\"></span>\n";